import {
  styled,
  Box,
  Dialog,
  DialogContent,
  IconButton,
  dialogClasses,
} from '@mui/material';

export const DialogConfigAndPreferencesContainer = styled(Dialog)({
  [`& .${dialogClasses.paper}`]: {
    maxWidth: 935,
    width: '100%',
    minHeight: 'calc(100% - 64px)',
  },
});

export const DialogConfigAndPreferencesHeader = styled(Box)(({ theme }) => ({
  flex: 'none',
  padding: theme.spacing(2, 3),
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const DialogConfigAndPreferencesHeaderCloseIcon = styled(IconButton)(
  ({ theme }) => ({
    color: theme.palette.grey[500],
  }),
);

export const DialogConfigAndPreferencesContent = styled(DialogContent)(
  ({ theme }) => ({
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
  }),
);
